module.exports = __webpack_public_path__ + "img/NOTAXI.bdb60db1.png";